import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";

import BasicTextFields from "./addComment/addComment";
import AutoGridNoWrap from "./showComments/showComment";
import ShowWorklog from "../../worklog/showWorklog";
import "./detailGrid.scss";
import Description from "./description/description";
import SidebarGrid from "../sidebar/sidebar";
import AttachmentCard from "../showDetailAttachment/showDetailAttachment";
import History from "./history";
import AllDetail from "./showAllDetail/AllDetail";
import EditTitle from "./editTitle";
import Chatbot from "../sidebar/components/Chatbot";
import Activity from "./Activity";
import { useDetailGridState } from "./hooks/useDetailGridState";

function BasicGrid({
  cardId,
  description,
  title,
  data,
  cardDescription,
  isfocus,
  handleDescriptionSave,
  setCardTitle,
  boardPermission,
}) {
  const {
    activeTab,
    addWorklogPermission,
    aiEnabled,
    canEditCard,
    currentCard,
    handleActiveTab,
    handleTextEditor,
    isMobile,
    setTextEditer,
    textEditor,
    toggleChatbotVisibility,
  } = useDetailGridState({
    cardId,
    cardData: data,
    boardPermission,
  });
  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid container spacing={2}>
        <Grid
          item
          xs={isMobile ? 12 : 8}
          sx={{
            // height: "100vh",
            overflowY: "auto",
            paddingTop: isMobile ? "8px !important" : "",
            paddingBottom: isMobile ? "100px !important" : "0",
          }}
        >
          <div>
            <EditTitle
              cardId={cardId}
              title={title}
              id={data?.board?.board_id}
              hasEditCardPermission={canEditCard}
            />
            <div className="description description-mobile-label">
              Description
            </div>

            <Description
              description={description}
              setTextEditer={() => setTextEditer(false)}
              handleTextEditor={handleTextEditor}
              accessToUpdate={canEditCard}
              cardDescription={cardDescription}
              isfocus={isfocus}
              handleDescriptionSave={handleDescriptionSave}
              toggleChatbotVisibility={toggleChatbotVisibility}
            />

            <AttachmentCard cardId={cardId} />
            {isMobile ? (
              aiEnabled ? (
                <Chatbot
                  cardData={currentCard}
                  toggleChatbotVisibility={toggleChatbotVisibility}
                  cardDescription={cardDescription}
                  setCardTitle={setCardTitle}
                />
              ) : (
                <SidebarGrid
                  cardId={cardId}
                  boardPermission={boardPermission}
                />
              )
            ) : (
              ""
            )}
            <Activity
              activeTab={activeTab}
              handleActiveTab={handleActiveTab}
              isMobile={isMobile}
              addWorklogPermission={addWorklogPermission}
              cardId={cardId}
            
            />
            {activeTab === "all" && (
              <div>
                <AllDetail cardId={cardId}  
                 boardPermission={boardPermission} />
              </div>
            )}
            {activeTab === "comment" && (
              <div>
                <BasicTextFields cardId={cardId} />
                <div>
                  <AutoGridNoWrap cardId={cardId} />
                </div>
              </div>
            )}
            {activeTab === "worklog" && (
              <div>
                <ShowWorklog
                  textEditor={textEditor}
                  cardId={cardId}
                  boardPermission={boardPermission}
                  isMobile={isMobile}
                  addWorklogPermission={addWorklogPermission}
                />
              </div>
            )}
            {activeTab === "history" && <History cardId={cardId} />}
          </div>
        </Grid>
        <Grid item xs={isMobile ? 12 : 4}>
          {!isMobile ? (
            aiEnabled ? (
              <Chatbot
                cardData={currentCard}
                toggleChatbotVisibility={toggleChatbotVisibility}
                cardDescription={cardDescription}
                setCardTitle={setCardTitle}
              />
            ) : (
              <>
                <SidebarGrid
                  cardId={cardId}
                  boardPermission={boardPermission}
                />
              </>
            )
          ) : (
            ""
          )}
        </Grid>
      </Grid>
    </Box>
  );
}

export default React.memo(BasicGrid);
